import {inject} from 'mobx-react'
import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import {rootStore} from '../../mobx/store'
import strings from '../../lang/strings'
import TableHeader from '../../components/control/table/table_header'
import TableCell from '../../components/control/table/table_cell'
import AppInput from '../../components/control/custom_input/app_input'
import ConfirmButton from '../../components/control/button/confirm_button'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import PageSubHeader from '../../components/common/page_sub_header'
import {MenuMy} from '../../config/page_route'
import RegisterButton from '../../components/control/button/regitser_button'
import { customDateFormat, formatNumber, string, drawTableBJPointCell, drawTableArticleType, drawTableTitleCell } from '../../helper/common'

const ProductInfo = (props) => {
  const me = rootStore.getMe
  const context = useContext(Page_settings)
  let [itemList, setItemList] = useState([])
  const tbHeaders = [
    {
      name: strings.item_name,
      class: 'tb-item-name',
    },
    {
      name: strings.price_p,
      class: 'tb-item-price',
    },
    {
      name: strings.item_period,
      class: 'tb-item-period',
    },
    {
      name: strings.item_description,
      class: 'tb-item-desc',
    },
    {
      name: strings.tb_item_manage,
      class: 'tb-item-manage',
    },
  ]
  const active = 1;

  const goProductNew = () => {
    props.history.push(`/product_new`)
  }

  useEffect(() => {
    getItemList();
  }, [])

  const getItemList = (filters = {}) => {
    // 요청할 데이터 구성
    const requestData = {
      ...filters 
    };
  
    // 서버로 요청 보내기
    context.post(
      'product/get_my_product_list',
      requestData,
      (response) => {
        // 성공 시 상태 업데이트
        setItemList(response.products);
      },
      true,
      (err) => {
       
      }
    );
  };

  const displayOpenCloseTime = (open, close) => {
    if (!open && !close) {
      return strings.item_open_forever; // 둘 다 없을 경우 표시할 텍스트
    }
  
    if (open && close) {
      return `${customDateFormat(open)} ~ ${customDateFormat(close)}`;
    }
  
    if (open) {
      return `${customDateFormat(open)} ~`; // open만 있을 경우
    }
  
    return `~ ${customDateFormat(close)}`; // close만 있을 경우
  };
  
  const onDelete = (product_id) => {
    // 삭제 확인 알림 표시
    context.showConfirm(
      strings.confirm_delete_product, // 삭제 확인 메시지
      (confirm) => {
        if (!confirm) return; // 사용자가 취소를 선택한 경우 아무 작업도 수행하지 않음
  
        // 삭제 요청
        context.post(
          'product/delete_product', // 삭제 API 엔드포인트
          { id: product_id }, // 요청 데이터
          () => {
            // 성공적으로 삭제된 경우
            context.showAlert(strings.product_deleted_successfully, () => {
              // UI 업데이트 - 목록 새로고침 또는 해당 아이템 제거
              setItemList((prevList) =>
                prevList.filter((product) => product.id !== product_id)
              );
            });
          },
          true, // 로딩 스피너 활성화
          (err) => {
            // 삭제 실패 시 오류 메시지 표시
            context.showAlert(err.msg);
          }
        );
      },
      strings.confirm // 확인 버튼 텍스트
    );
  };

  const onModify = (product_id) => {
    props.history.push(`/product_new/${product_id}`)
  };
  


  return (
    <React.Fragment>
      <div className='content-container'>
        <SidebarLeft menu={MenuMy} active={active} history={props.history} />
        <div className='im-container im-container-item'>
          <PageSubHeader pageName={strings.my_product_info} pageMenu1={strings.main} pageMenu2={strings.mypage} pageMenu={strings.my_product_info}/>
          <div className='mt-30 sm-mt-15 d-flex align-items-center'>
            <div className='fs-20 f-b color-3a3335 flex-full sm-invisible'>{strings.product_info}</div>
            <RegisterButton name={strings.product_new} onClick={goProductNew}></RegisterButton>
          </div>
          <TableHeader className={'mt-18 sm-mt-12'} headers={tbHeaders}/>
          {
            itemList.map((info, index) => {
              return (
                <div key={index} className='tb-row'>
                  <TableCell
                    value={info.name}
                    className={tbHeaders[0].class}
                    center={tbHeaders[0].center}
                    child={null}
                  />
                  <TableCell
                    value={string.Format(strings.price_format, formatNumber(info.price))}
                    className={tbHeaders[1].class}
                    center={tbHeaders[1].center}
                    child={null} 
                  />
                  <TableCell
                    value={string.Format(strings.item_package_period, info.period)}
                    className={tbHeaders[2].class}
                    center={tbHeaders[2].center}
                    child={null}
                  />
                  <TableCell
                    value={''}
                    className={tbHeaders[3].class}
                    center={tbHeaders[3].center}
                    child={
                      <div>
                        {info.description}
                      </div>
                    }
                  />
                  <TableCell
                    value={''}
                    className={tbHeaders[4].class}
                    center={tbHeaders[4].center}
                    child={
                    <div className={'d-center w-100 h-100 tb-item-manage-btn-container'}>
                    <ConfirmButton
                      className={'bd-0 item-data-button w-100 fs-14 f-m' }
                      onClick={() => { onModify(info.id); }}
                      text={strings.modify}
                    />
                    <ConfirmButton
                      className={'bd-0 item-data-button w-100 fs-14 f-m' }
                      onClick={() => { onDelete(info.id); }}
                      text={strings.delete}
                    />

                    </div>
                  }
                  />


                </div>
              )
            })
          }
        </div>
      </div>
    </React.Fragment>
  )
}

export default withRouter(inject('rootStore')(ProductInfo))
